import React from 'react'

interface ContactSupportMessageProps {
  email?: string
}

const ContactSupportMessage: React.FC<ContactSupportMessageProps> = ({
  email = 'techsupport@designsforhealth.com',
}) => (
  <>
    Contact <span className="select-all">{email}</span> if you have any questions.
  </>
)

export default ContactSupportMessage
